<template>
  <svg
    role="img"
    aria-label="no-results icon"
    class="no-results-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 86 86"
  >
    <title>No Results Graphic</title>
    <path
      d="M42.9999 2.36523C41.7637 2.36523 40.7603 3.36857 40.7603 4.60482C40.7603 5.84107 41.7637 6.8444 42.9999 6.8444C63.0039 6.8444 79.2812 23.1217 79.2812 43.1257C79.2812 46.7448 78.7437 50.2386 77.7493 53.5442C75.1514 51.0269 69.3285 46.6642 60.1999 46.6642C47.6672 46.6642 41.3337 54.9148 41.0739 55.2642C40.3303 56.2496 40.5364 57.6471 41.5128 58.3907C42.4983 59.1342 43.8958 58.9371 44.6483 57.9607C44.8633 57.6829 49.9785 51.1434 60.1999 51.1434C70.4214 51.1434 75.5366 57.6829 75.7426 57.9517C75.8143 58.0502 75.9039 58.1219 75.9845 58.2025C70.2512 70.6994 57.6289 79.4069 42.9999 79.4069C22.996 79.4069 6.71867 63.1296 6.71867 43.1257C6.71867 41.8894 5.71534 40.8861 4.47909 40.8861C3.24284 40.8861 2.2395 41.8894 2.2395 43.1257C2.2395 65.6021 20.5235 83.8861 42.9999 83.8861C65.4764 83.8861 83.7603 65.6021 83.7603 43.1257C83.7603 20.6492 65.4764 2.36523 42.9999 2.36523Z"
      fill="currentColor"
      fill-opacity="0.7"
    />
    <path
      d="M10.1229 14.5484C11.3591 14.5484 12.3625 13.5451 12.3625 12.3088C12.3625 6.27988 18.8035 5.41092 21.6075 7.99093C22.7093 9.00322 23.2916 10.4903 23.2916 12.3088C23.2916 14.9426 22.1539 15.9818 20.4339 17.5495C18.275 19.5203 15.5875 21.9749 15.5875 27.7172C15.5875 28.9534 16.5908 29.9568 17.8271 29.9568C19.0633 29.9568 20.0666 28.9534 20.0666 27.7172C20.0666 23.9457 21.5627 22.5841 23.4529 20.8551C25.3789 19.0993 27.7708 16.9134 27.7708 12.3088C27.7708 5.61697 22.772 2.11426 17.8271 2.11426C12.8821 2.11426 7.8833 5.61697 7.8833 12.3088C7.8833 13.5451 8.88663 14.5484 10.1229 14.5484Z"
      fill="currentColor"
      fill-opacity="0.7"
    />
    <path
      d="M16.2147 37.7594L16.1788 37.8042C15.3457 38.7179 15.4263 40.1154 16.3311 40.9486C16.7522 41.3338 17.2897 41.5309 17.8361 41.5309C18.4543 41.5309 19.0724 41.28 19.5203 40.7963C20.3534 39.8825 20.2907 38.4671 19.3859 37.634C18.4722 36.8009 17.0568 36.8636 16.2236 37.7684L16.2147 37.7594Z"
      fill="currentColor"
      fill-opacity="0.7"
    />
    <path
      d="M70.1438 29.6432C70.1438 27.3498 68.2715 25.4775 65.9781 25.4775C63.6848 25.4775 61.8125 27.3498 61.8125 29.6432C61.8125 31.9365 63.6848 33.8088 65.9781 33.8088C68.2715 33.8088 70.1438 31.9365 70.1438 29.6432Z"
      fill="currentColor"
      fill-opacity="0.7"
    />
    <path
      d="M39.0135 33.8088C41.3069 33.8088 43.1791 31.9365 43.1791 29.6432C43.1791 27.3498 41.3069 25.4775 39.0135 25.4775C36.7202 25.4775 34.8479 27.3498 34.8479 29.6432C34.8479 31.9365 36.7202 33.8088 39.0135 33.8088Z"
      fill="currentColor"
      fill-opacity="0.7"
    />
  </svg>
</template>

<style lang="scss" scoped>
.no-results-icon {
  height: 86px;
  width: 86px;
}
</style>
